module.exports = __webpack_public_path__ + "static/img/staysafe-hbv.85fcc68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stdfastces/staysafe-hbv.png
// module id = G/Qh
// module chunks = 0